// extracted by mini-css-extract-plugin
export default {"container":"Q2fbbB","screenShare":"vqDxWs"};